/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 03.03.14
 * Time: 17:58
 * To change this template use File | Settings | File Templates.
 */

import { TrackingEventIds } from "../tracking/constants/TrackingEventIds";
import { BasicTrackingEvent } from "./BasicTrackingEvent";

import { Capabilities } from "@goodgamestudios/createjs-utilities";

export class DesktopDeviceInformationTrackingEvent extends BasicTrackingEvent {
    public playerId: number = 0;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};

        vars.eventId = TrackingEventIds.DESKTOP_DEVICE_INFORMATION;
        vars.event_mapping_version = 2;
        vars.playerId = this.playerId;
        vars.screenResolutionX = Capabilities.screenResolutionX;
        vars.screenResolutionY = Capabilities.screenResolutionY;
        vars.browserString = Capabilities.version;
        vars.desktopOs = Capabilities.os;
        vars.flashVersion = "";

        return vars;
    }
}
